var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-dashboard"},[_c('div',{staticClass:"top-logo"},[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.logo,"width":"160","alt":""},on:{"click":_vm.turnToHome}})]),_c('iframe',{attrs:{"id":"myframe","src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }